// extracted by mini-css-extract-plugin
module.exports = {"offlinePay":"index_offlinePay_3VQGm","hint":"index_hint_HpDbv"};